'use es6';

export const getReviewFilters = state => state.reviews.filters;